/**
 * A collection of helper functions for bootstrap 4
 */
export module BootstrapHelpers {

    var bootstrap = (globalThis as any).bootstrap;

    export function IsDropdownMenu(elementSelector: string) {
        return $(elementSelector).hasClass('dropdown-menu');
    }

    export function IsDropdownMenuShown(elementSelector: string) {
        return $(elementSelector).hasClass('show');
    }

    export function GetDropdownMenuLink(menuElementSelector: string) : JQuery<HTMLElement> {
        // We need to find the previous dropdown-toggle element and click it
        return $(menuElementSelector).prev('.dropdown-toggle');
    }

    export function IsTab(elementSelector: string) {
        return $(elementSelector).hasClass('nav-item');
    }

    export async function ShowTabBySelector(elementSelector: string) {
        $(elementSelector).tab('show');
        // Wait a bit for the tab to render
        await new Promise(resolve => setTimeout(resolve, 250));;
    }

    // Show the specified tab.
    // htmlElement is the a link for the tab
    export function ShowTab(htmlElement: HTMLElement) {
        new bootstrap.Tab(htmlElement).show();
    }

    export function InitialiseBootstrapTooltips() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl: any) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        })
    }

    export function TooltipHtmlFor(message: string) : string {
        return `<span class="info-icon" data-bs-toggle="tooltip" data-bs-placement="top" title="${message}"><i class="fas fa-info-circle"></i></span>`;
    }

    export function MoreInfoHtmlFor(moreInfoUrl: string) : string {
        return `<span class="info-icon" data-bs-toggle="tooltip" data-bs-placement="top" title="More Info"><a href="${moreInfoUrl}" target="_blank" rel="noopener noreferrer"><i class="fas fa-circle-question"></i></a></span>`;
    }

    export function ClearTooltip(jquerySelector: JQuery<HTMLElement>) {
        jquerySelector.removeAttr('title');
        jquerySelector.tooltip('dispose');
    }

    export function AddTooltip(jquerySelector: JQuery<HTMLElement>, tooltipText: string) {
        jquerySelector.data('bs-toggle', "tooltip");
        jquerySelector.data('bs-placement', "top");
        jquerySelector.attr('title', tooltipText);
        jquerySelector.tooltip();
    }

    /**
     *  Closes a bootstrap dropdown menu and optionally sets the autoClose property
     * @param dropdownMenuLinkSelector
     * @param disableAutoClose
     * @returns
     */
    export function CloseDropdownMenu(dropdownMenuLinkSelector: string, autoClose?: boolean) {

        // Find the dropdown menu link element
        const $dropdownMenuLink = $(dropdownMenuLinkSelector);

        if ($dropdownMenuLink.length === 0) {
            return;
        }

        const dropdown = new bootstrap.Dropdown($dropdownMenuLink[0]);

        dropdown.hide();

        if (autoClose !== undefined) {
            dropdown._config.autoClose = autoClose;
        }
    }

    /**
     * Opens a bootstrap dropdown menu and returns a promise which resolves when the dropdown menu is visible
     * @param dropdownMenuLinkSelector
     * @returns
     */
    export function OpenDropdownMenuFromLink(dropdownMenuLinkSelector: string, disableAutoClose?: boolean): Promise <void> {
        return new Promise((resolve, reject) => {
            // Ensure jQuery is loaded
            if (typeof jQuery === 'undefined') {
                reject(new Error('jQuery is not loaded'));
                return;
            }

            // Find the dropdown menu link element
            const $dropdownMenuLink = $(dropdownMenuLinkSelector);

            if ($dropdownMenuLink.length === 0) {
                reject(new Error('Dropdown menu link element not found'));
                return;
            }

            try {
                // Bootstrap 5 dropdown instance
                const dropdown = new bootstrap.Dropdown($dropdownMenuLink[0]);

                // Open the dropdown
                dropdown.show();

                // Disable close on click
                if (disableAutoClose === true) {
                    dropdown._config.autoClose = false;
                }
                resolve();

            } catch (error) {
                reject(error);
            }
        });
    }

    export function ClickButton(buttonSelector: string) {
        const $button = $(buttonSelector);

        if ($button.length === 0) {
            return;
        }

        $button.click();
    }
}